import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoader = _resolveComponent("SpinnerLoader")!
  const _component_ConversationCard = _resolveComponent("ConversationCard")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_SpinnerLoader, { key: 0 }))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.conversations, (conversation) => {
            return (_openBlock(), _createBlock(_component_ConversationCard, {
              key: conversation.id,
              conversation: conversation
            }, null, 8, ["conversation"]))
          }), 128))
    ]),
    _: 1
  }))
}